import { useEffect } from 'react';

const ViewportManager: React.FC = () => {
  useEffect(() => {
    // Get existing viewport meta tag if it exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    // If there are multiple viewport meta tags, use the first one and remove others
    const allViewportMetas = document.querySelectorAll('meta[name="viewport"]');
    if (allViewportMetas.length > 1) {
      console.warn('Multiple viewport meta tags found. Using the first one.');
      
      // Keep the first one, remove the rest
      for (let i = 1; i < allViewportMetas.length; i++) {
        allViewportMetas[i].remove();
      }
      
      viewportMeta = allViewportMetas[0];
    }
    
    // If no viewport meta tag exists, create one
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      (viewportMeta as HTMLMetaElement).name = 'viewport';
      document.head.appendChild(viewportMeta);
    }
    
    // Set optimal mobile viewport
    viewportMeta.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
    );
    
    // No need for cleanup as we want this to persist
  }, []);
  
  return null;
};

export default ViewportManager;